export default __webpack_public_path__ + "static/media/profile8.76ea75bd.png";